var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTelegram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 19,
    viewBox: "0 0 24 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1421_1015)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.63709 12.5271L9.26604 17.5567C9.79686 17.5567 10.0268 17.337 10.3025 17.073L12.7913 14.7806L17.9483 18.4205C18.8942 18.9285 19.5605 18.661 19.8156 17.5819L23.2007 2.29488L23.2016 2.29398C23.5016 0.946498 22.696 0.419574 21.7745 0.750138L1.87723 8.09192C0.51928 8.59994 0.539841 9.32954 1.64639 9.66005L6.73332 11.185L18.5492 4.05939C19.1054 3.7045 19.611 3.90087 19.1951 4.25574L9.63709 12.5271Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1421_1015"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 19,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegram);
export default __webpack_public_path__ + "static/media/telegram.3f9071d40f3fcc44a18cea69ccfd167e.svg";
export { ForwardRef as ReactComponent };